/*!
 * vue-plugin-localforage v0.0.1
 * ahles@ditoy.com
 * Released under the MIT License.
 */
'use strict'

const localForage = require('localforage')
require('localforage-startswith')
require('localforage-getitems')

let stores = new Map()

export default function VuePluginLocalforage (Vue) {
  Vue.prototype.$setStore = function (databaseName, storeName) {
    let store = localForage.createInstance({
      name: databaseName,
      driver: localForage.INDEXEDDB,
      storeName: storeName
    })
    stores.set(storeName, store)
  }

  Vue.prototype.$getStore = function (storeName) {
    if (stores.get(storeName) !== undefined) {
      return stores.get(storeName)
    }
    return null
  }
}

VuePluginLocalforage.version = '0.0.1'



// WEBPACK FOOTER //
// ./src/lib/vue-plugin-localforage.js